import React from "react";
import usePermission from "../hooks/usePermission";

type PermissionType = "can_view" | "can_add_edit" | "can_be_delete";

type ModuleName =
  | "Dashboard"
  | "Notification Management"
  | "Manage Customer Support"
  | "Settings"
  | "Manage Customers"
  | "Manage Analytics"
  | "Manage CMS"
  | "Manage Subscriptions"
  | "Manage SubAdmin"
  | "Budget Intelligence"
  | "Document Processing"
  | "Hydration And Goal"
  | "Label Recognition"
  | "Location Intelligence"
  | "Manage Revenue"
  | "Shared Account"
  | "Shopping Meals"
  | "Translation Messaging"
  | "Reminder Engine"
  | "AI Behavior Language";

interface PermissionGuardProps {
  module: ModuleName;
  permissionType?: PermissionType;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  module,
  permissionType = "can_view",
  children,
  fallback = null,
}) => {
  const { isLoading, hasPermission } = usePermission({
    module,
    permission_type: permissionType,
  });

  if (isLoading) return null;
  if (!hasPermission) return <>{fallback}</>;
  return <>{children}</>;
};

export default PermissionGuard;


